import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Автокемпинг в г. Бресте на 60 мест';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <h3>Auto camping in Brest on 60 places</h3>

                    <h4>А. Описание возможностей проекта</h4>
                    <p>А1 Название проекта: <strong>Строительство автокемпинга в г. Бресте на 60 мест для обслуживания транзитных туристов</strong></p>
                    <p>(а) Краткое название: Строительство автокемпинга</p>
                    <p>(b) Полное название: Строительство автокемпинга в г. Бресте на 60 мест для обслуживания транзитных туристов</p>
                    <p>(c) Краткое описание (аннотация). Настоящий проект предусматривает строительство в районе перспективной кольцевой автотрассы, примыкающей к гребному каналу, двухэтажного корпуса для проживания, бар, автостоянку, станцию техобслуживания, торговую точку.</p>
                    <p>А2 Состояние проекта: НПрединвестиционная стадия. Объект включен в мероприятия по развитию туризма до 2010 года, утвержденные Брестским облисполкомом. Указом Президента Республики Беларусь на период строительства к эксплуатации предусмотрены льготы. Имеется технико-экономическое обоснование </p>
                    <p>А3 Участвующие организации и их роль (контактные лица, телефон, факс, е-mail, страница в Интернет</p>
                    <ol>
                        <li>Брестский горисполком: Республика Беларусь, 224005, г. Брест, ул. Энгельса, 3, тел./факс (+375 162) 23-70-64, 23-45-03, 23-54-70, Лаптейкин Валерий Михайлович, Хафизов Вячеслав Талипович </li>
                        <li>Инициатор проекта: Иностранный или отечественный инвестор - владелец контрольного пакета акций. Управление по физической культуре, спорту и туризму. </li>
                    </ol>
                    <p>А4 Описание проекта (подходы, задачи, компоненты, результаты, этапы, сроки, общее финансирование, преимущества, влияние на переходные процессы в экономике и т.д.)</p>
                    <p>Оказание услуг по проживанию, питанию, отдыху по международным стандартам для транзитных автотуристов, услуг по техобслуживанию автотранспорта.</p>
                    <p>А5 Предпосылки (история, общая программа, взаимосвязанные или схожие проекты): Отсутствие подобных объектов в районе перспективной кольцевой автотрассы.</p>
                    <p>А6 Краткое описание влияния на окружающую среду: Зкологически безопасный проект</p>
                    <p>А7 Возможные препятствия/проблемы/степень риска: Отсутствуют</p>
                    <p>А8 Срок реализации и окупаемости проекта (лет): Срок реализации проекта 3 года, срок окупаемости 5 лет.</p>
                    <p>А9 Отраслевая принадлежность проекта: Ослуживание в сфере туризма.</p>

                    <h4>В. Статьи капитальных затрат (суммарные инвестиции, необходимые для реализации проекта):</h4>
                    <p>В1 Физические компоненты проекта (оборудование, работы, услуги и др. необходимые для реализации проекта): Проект на стадии разработки.</p>
                    <p>Итого (должна равняться сумме С2+D4)</p>

                    <h4>С. Капитал по источнику происхождения, имеющейся в наличии инициаторов проекта (собственников, соучастников, спонсоров и т.п.)</h4>
                    <p>Нет.</p>

                    <h4>D. Требуемые инвестиции, недостающие средства</h4>
                    <p>D1 Недостаток финансовых средств, вид финансовой помощи (кредит, долевое участие и др.): Недостаток финансовых средств – иностранные инвестиции.</p>

                    <h4>Е. Спрос (потребители) и доходы</h4>
                    <p>-</p>

                    <h4>F. Операционные и эксплуатационные расходы</h4>
                    <p>-</p>

                    <h4>G. Чистый доход</h4>
                    <p>-</p>

                    <h4>Н. Источник информации о проекте</h4>
                    <p>-</p>
                </div>
            </div>
        </>
    );
}